import BaseIvrNode from 'src/models/Ivrs/Nodes/baseIvrNode';

export default class VerifyAuthCode extends BaseIvrNode {}
